<template>
  <div class="chooseItem" id="step-3" v-if="hasColor">
    <div class="wrap">
      <div class="title-wrap">
        <p class="fs-36 color-black bold">
          {{ blockTitle }}
        </p>
        <button
          v-if="isCompleted"
          class="btn btn-link"
          @click="reset"
        >
          {{ trans.change }}
        </button>
      </div>

      <collapse-transition :duration="800">
        <div v-if="isActive && !isCompleted">
          <ul class="nav-mobile-tabs">
            <li
              v-for="group in preselected.color.list"
              :key="group.id"
              class="nav-item"
            >
              <a :class="tabClass(group)" class="nav-link" @click.prevent="selectGroup(group)">
                {{ trans[group.title] }}
                <span v-if="group.price > 0">
            {{ $crConverter(group.price / 100, 'EUR', '%s +%v') }}
          </span>
              </a>
            </li>
          </ul>

          <div class="tabs">
            <div
              v-for="group in preselected.color.list"
              :id="`group-${group.id}`"
              :key="group.id"
              :class="isGroupSelected(group)"
              class="groupColor"
            >
              <div class="color-title">
                <p class="fs-24 medium">{{ trans[group.title] }}</p>
                <p v-if="group.price > 0" class="fs-24">
                  {{ $crConverter(group.price / 100, 'EUR', '%s +%v') }}
                </p>
              </div>

              <ul class="checkbox-list color-wrap">
                <li
                  v-for="color in group.colors"
                  :key="color.id"
                  :class="colorOptionClass(color)"
                  class="checkboxEl"
                  @click="selectColor(color)"
                >
                  <div class="stripe"/>
                  <img
                    :alt="color.title"
                    :src="color.image"
                    class="icColor"
                  />
                  <p class="nameColor">
                    {{ color.title }}
                  </p>
                  <p v-if="false" class="textColor">{{ trans['full_payment'] }}</p>
                </li>
              </ul>
            </div>
          </div>

          <div
            v-if="showCustomColorBtn && false"
            class="customColor"
          >
            <p class="fs-24 medium">{{ trans['custom_colour'] }}</p>
            <p class="fs-24">{{ customColorPrice }}</p>

            <button
              :class="colorOptionClass(this.customColor)"
              class="btn btn-color"
              @click="toggleCustomColor"
            >
              <svg
                fill="none"
                height="23"
                viewBox="0 0 24 23"
                width="24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M8.68359 16.4806V11.5003C8.68359 10.8891 9.17875 10.395 9.78886 10.395H14.2099C14.8211 10.395 15.3152 10.8891 15.3152 11.5003V16.4806M17.7272 20.3422C17.7272 18.0986 15.9079 16.2793 13.6631 16.2793H10.3363C8.09257 16.2793 6.27441 18.0986 6.27441 20.3422M14.0892 5.58411L9.63277 7.36469C9.52666 7.40669 9.45703 7.51058 9.45703 7.62443V10.3953H14.6993V5.99748C14.6993 5.68248 14.3821 5.46695 14.0892 5.58411ZM22.5 11.5C22.5 17.2993 17.7993 22 12 22C6.20179 22 1.5 17.2993 1.5 11.5C1.5 5.70068 6.20179 1 12 1C17.7993 1 22.5 5.70068 22.5 11.5Z"
                  stroke="url(#paint0_linear)"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="1.5"
                />
                <defs>
                  <linearGradient
                    id="paint0_linear"
                    gradientUnits="userSpaceOnUse"
                    x1="1"
                    x2="23"
                    y1="12.5"
                    y2="12.5"
                  >
                    <stop stop-color="#D5003E"/>
                    <stop offset="1" stop-color="#C80051"/>
                  </linearGradient>
                </defs>
              </svg>

              <span>{{ trans['own_style'] }}</span>
            </button>

            <p class="fs-11 color-gray">{{ trans['own_style_description'] }}</p>
          </div>

          <button
            :class="confirmBtnClass"
            :disabled="isDisabled"
            class="btn btn-green"
            type="button"
            @click="confirmSelected"
          >
            {{ trans['confirm_build'] }}
          </button>
        </div>
      </collapse-transition>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import {CollapseTransition} from "@ivanv/vue-collapse-transition";

export default {
  name: "BuildColorSelector",
  props: {
    trans: {
      required: true
    }
  },
  components: {
    'collapse-transition': CollapseTransition
  },
  data() {
    return {
      customColorSelected: false,
      selectedGroup: null
    }
  },
  computed: {
    ...mapGetters({
      groups: 'build/colorGroupsList',
      steps: 'build/stepList',
      custom: "build/customColor",
      loading: "build/selectorLoading",
      preselected: "build/preselected",
    }),
    build() {
      return this.preselected?.build || null
    },
    selectedTitle() {
      return this.preselected?.title?.selected || null
    },
    selectedModel() {
      return this.preselected?.model?.selected || null
    },
    selectedColor() {
      return this.preselected?.color?.selected || null
    },
    customColor: {
      get() {
        return this.custom
      },
      set(value) {
        this.$store.commit('build/setCustomColor', value)
      }
    },
    showCustomColorBtn() {
      return this.isActive && !this.isCompleted && this.customColor
    },
    customColorPriceClean() {
      return this.selectedModel['custom_color_price_for_eu'] / 100
    },
    customColorPrice() {
      return this.$crConverter(this.customColor.price / 100, 'EUR', '%s +%v')
    },
    hasColor() {
      return this.preselected && this.preselected.color
    },
    isCompleted() {
      return this.hasColor && this.preselected.color.completed
    },
    isActive() {
      return this.hasColor && this.preselected.color.active
    },
    isDisabled() {
      if (!this.hasColor) {
        return true
      }

      if (this.customColorSelected) {
        return false
      } else {
        return this.preselected.color.selected === null || this.loading
      }
    },
    confirmBtnClass() {
      return {
        disabled: this.isDisabled
      }
    },
    blockTitle() {
      if (this.isCompleted) {
        return this.preselected.color.selected.title
      }
      return this.trans['choose_your_colour']
    }
  },
  mounted() {
    this.$root.$on('colorPreselect', build => {
      let group = this.groups.find(gp => {
        return gp.id === build.color['group_id']
      })

      let color = group.colors.find(c => {
        return c.id === build.color.id
      })

      this.selectColor(color)
      this.confirmSelected(null, true)
    })

    this.$nextTick(() => {
      setTimeout(() => {
        if (!this.selectedGroup && Array.isArray(this.preselected.color.list) && this.preselected.color.list?.length > 0) {
          this.selectedGroup = this.preselected.color.list[0]
        }
      }, 400)
    })
  },
  methods: {
    tabClass(group) {
      return {
        active: this.selectedGroup && this.selectedGroup.id === group.id
      }
    },
    selectGroup(group) {
      this.selectedGroup = group
    },
    isGroupSelected(group) {
      return {
        show: this.selectedGroup && this.selectedGroup.id === group.id
      }
    },
    reset() {
      this.$store.commit('build/setSelectorLoading', true)

      let preselected = {...this.preselected}

      preselected.color.selected = null

      preselected.model.completed = true
      preselected.model.active = false
      preselected.title.active = false
      preselected.title.completed = true
      // preselected.brakes.active = false
      // preselected.brakes.completed = true
      preselected.color.active = true
      preselected.color.completed = false
      preselected.size.active = false
      preselected.size.completed = false

      this.$store.commit('build/setPreselected', {...this.preselected, ...preselected})


      this.$store.dispatch('build/updatePreselected').then(ps => {
        this.$store.commit('build/setSelectorLoading', false)
        this.$store.commit('build/setPreselected', {...this.preselected, ...ps})

        history.pushState({}, "", `${location.origin}/en/choose/${this.preselected.model.selected.slug}/${this.preselected.title.selected.slug}`)
        // history.pushState({}, "", `${location.origin}/en/choose/${this.preselected.model.selected.slug}/${this.preselected.title.selected.slug}/${this.preselected.brakes.selected.slug}`)
      })
    },
    selectColor(color, disableCustom = true) {
      this.$store.commit('build/setSelectedColor', color)
      if (disableCustom) {
        this.customColorSelected = false
      }
    },
    isSelected(color) {
      return this.hasColor && this.preselected.color.selected && this.preselected.color.selected.id === color.id
    },
    colorOptionClass(color) {
      return {
        active: this.isSelected(color)
      }
    },
    confirmSelected(event, skipStep = false) {
      this.$store.commit('build/setSelectorLoading', true)

      this.$store.dispatch('build/updatePreselected').then(ps => {
        this.$store.commit('build/setSelectorLoading', false)
        this.$store.commit('build/setPreselected', {...this.preselected, ...ps})

        history.pushState({}, "", `${location.origin}${window.removeTrailingSlash(location.pathname)}/${this.preselected.color.selected.slug}`)

        setTimeout(() => {
          this.$root.$emit("scrollTo", {
            from: 4,
            to: 5
          })
        }, 250)
      })
      //
      // this.loading = true
      // this.$store.dispatch('build/selectColor', {
      //   path: this.$path,
      //   model: this.selectedModel,
      //   title: this.selectedTitle,
      //   color: this.selectedColor,
      // }).then(() => {
      //   this.$emit('onConfirmed', skipStep)
      // }).finally(() => {
      //   this.loading = false
      // })
    },
    toggleCustomColor() {
      if (!this.customColorSelected) {
        this.customColorSelected = true
        this.selectColor(this.customColor, false)
      }
    }
  },
  watch: {
    groups: {
      handler: function (value) {
        if (!this.selectedGroup && Array.isArray(value) && value?.length > 0) {
          this.selectedGroup = value[0]
        }
      },
      deep: true,
      immediate: true
    }
  }
}
</script>
